import axios from "axios";


export const allRoles = async (authtoken) => {
  return await axios.get(`${process.env.REACT_APP_API}/role`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};


export const roleDetails = async (authtoken, id) => {
  return await axios.get(`${process.env.REACT_APP_API}/role/${id}`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const addRole = async (authtoken, roleData) => {
  return await axios.post(`${process.env.REACT_APP_API}/role`, roleData, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const updateRoleApi = async (authtoken, id, updatedData) => {
  return await axios.patch(`${process.env.REACT_APP_API}/role/${id}`, updatedData, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};


export const deleteRoleApi = async (authtoken, id) => {
  return await axios.delete(`${process.env.REACT_APP_API}/role/${id}`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};
export const allModules = async (authtoken, id) => {
  return await axios.get(`${process.env.REACT_APP_API}/all-modules`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};
